// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  HOME_SET_SCATTER_CHART_AXIS,
} from './constants';

export function setScatterChartAxis(axis, value) {
  return {
    type: HOME_SET_SCATTER_CHART_AXIS,
    data: {axis, value}
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_SET_SCATTER_CHART_AXIS:
      return {
        ...state,
        scatterChart:
        {
          ...state.scatterChart,
          [action.data.axis]: action.data.value
        }
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/setScatterChartAxis.js